import { PATIENT_LIST_TAB } from '../../../../constants';

export const PATIENT_LIST_SEARCH_PLACEHOLDER = {
  [PATIENT_LIST_TAB.ACTIVE]: 'Patient or External Pharmacy Identifier...',
  [PATIENT_LIST_TAB.NEW]: 'Patient...',
};
